import { MoneylineFormFieldComponent } from './moneyline/form-field/moneyline-form-field.component';
import { MarketFormFieldComponent, MarketSortPipe } from './market/form-field/market-form-field.component';
import { BetslipFormFieldComponent } from './betslip/form-field/betslip-form-field.component';
import { OddsComponent } from './market/form-field/components/odds.component';

export const COMPONENTS: any[] = [
  MoneylineFormFieldComponent,
  MarketFormFieldComponent,
  BetslipFormFieldComponent,
  OddsComponent,
];

export const PIPES: any[] = [MarketSortPipe];

export const PAGES: any[] = [];

export const SERVICES: any[] = [];

export const DIRECTIVES: any[] = [];

export const MODULE_EXPORTS: any[] = [];

export { MoneylineFormFieldComponent, MarketFormFieldComponent, BetslipFormFieldComponent, OddsComponent };
